import { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import heroImages from '../config/heroImages';
import analytics from '../analytics';

const isTouch = () => window.matchMedia('(pointer: coarse)').matches;

const heroAlts = [
  'Switzerland skiing — glacier trekking in Saas Fee winter with alpine mountain panorama',
  'Alphubel Peak holiday apartment — Saas Fee Wohnung with mountain view',
  'Saas Fee village panorama with Mischabel massif — Saas Fee apartments',
  'Saas Fee village in winter — Switzerland skiing destination in the Swiss Alps',
];

const Hero = () => {
  const { t } = useLanguage();
  const [index, setIndex] = useState(0);
  const particlesRef = useRef(null);
  const touch = useRef(isTouch()).current;

  useEffect(() => {
    if (heroImages.length <= 1) return;
    const timer = setInterval(() => setIndex((p) => (p + 1) % heroImages.length), 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (touch) return; // skip particles on touch devices
    const container = particlesRef.current;
    if (!container) return;
    container.innerHTML = '';
    for (let i = 0; i < 55; i++) {
      const p = document.createElement('div');
      p.className = 'particle';
      p.style.cssText = `left:${Math.random()*100}%;width:${Math.random()*2.5+1}px;height:${Math.random()*2.5+1}px;animation-duration:${Math.random()*8+7}s;animation-delay:${Math.random()*10}s;`;
      container.appendChild(p);
    }
  }, [touch]);

  const bgStyle = heroImages.length > 0
    ? { backgroundImage: `url(/media/hero/${heroImages[index]})` }
    : {};

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="hero" style={bgStyle} aria-label="Alphubel Peak — Saas Fee holiday apartment">
      {heroImages.length > 0 && (
        <img src={`/media/hero/${heroImages[index]}`} alt={heroAlts[index] || 'Saas-Fee holiday apartment'} className="sr-only" width="1" height="1" />
      )}
      <div className="particles" ref={particlesRef} />

      <div className="hero-content">
        <div className="hero-tag">Saas-Fee · Switzerland · 1,800m</div>
        <h1 dangerouslySetInnerHTML={{ __html: t.hero.title.replace(/&/g, '&amp;') }} />
        <p className="hero-subtitle">{t.hero.subtitle}</p>
        <div className="hero-actions">
          <a href="#booking" className="btn-primary" onClick={(e) => { e.preventDefault(); scrollTo('booking'); analytics.ctaClick('hero_book_now'); }}>
            {t.hero.cta}
          </a>
          <a href="#about" className="btn-ghost" onClick={(e) => { e.preventDefault(); scrollTo('about'); analytics.ctaClick('hero_learn_more'); }}>
            {t.nav.about}
          </a>
        </div>
      </div>

      <div className="altitude-badge">
        <span className="num">1,800</span>
        <span className="unit">Metres above sea level</span>
      </div>

      <div className="scroll-hint">
        <span>Scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
};

export default Hero;
